(ns app.front.ui.error-list
  (:require [app.front.util :refer [for-frag]]
            [app.front.view.workspace.subs :as ws-subs]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.icons :as i]
            [potpuri.core :as p]))

(defn error-list
  "Presentational error list. Takes `:loading?`, a sequence of display strings in `:errors`,
  and the translated icon description in `:error-label`. Loading replaces the list with skeleton text."
  [{:keys [loading? errors error-label]}]
  (if loading?
    (cc/skeleton-text)
    (when (seq errors)
      [:ul.mr-2.primary-action__guard-errors {:id "errors-guard-results"}
       (for-frag [text errors]
         [:li
          [:div.flex.items-center.mb-2
           (cc/icon {:icon        i/circle-attention
                     :description error-label
                     :fill        "#616161"
                     :class-name  "mr-2 w-6 flex-shrink-0"})
           [:div text]]])])))

(defn- guard-error-text [tr lang [guard-id result]]
  (let [tr-args   (-> result ex-data :error-translation-keys)
        guard-tr  (or (-> result ex-data :main-error-translation-key) guard-id)
        tr-params (cond
                    ;; Guard exception arguments may contain translation keys or localized strings.
                    tr-args
                    [[guard-tr (str guard-tr)]
                     [(->> tr-args
                           (map #(if (and (coll? %)
                                          (->> % first (eu/is-type? :entity.type/localized-string)))
                                   (i18n-model/get-text % lang)
                                   (tr (p/wrap-into [] %))))
                           (str/join ", "))]]

                    result
                    [[guard-tr (str guard-tr)] [result]]

                    :else
                    [[guard-tr (str guard-tr)]])]
    (apply tr tr-params)))

(defn signal-error-list
  "Adapt FSM guard results to `error-list`, subscribing to loading state and language.
  Suppresses inapplicable signals and deduplicates guards before translating their results."
  [tr errors]
  (when (seq errors)
    (let [loading? (or (<sub [::ws-subs/loading-config?])
                       (<sub [:comm/command-processing? :group/process-states]))
          lang     (<sub [:language])]
      (when (or loading? (-> errors ffirst (not= :process/illegal-signal)))
        [error-list
         {:loading?    loading?
          :error-label (tr [:error/error])
          :errors      (when-not loading?
                         (->> errors
                              ;; Actions may trigger the same guards; show each guard only once.
                              (group-by first)
                              vals
                              (map (comp (partial guard-error-text tr lang) first))
                              (remove str/blank?)))}]))))
